import { AppState, FetchStatus } from '../../../redux/appState';

export interface PreferencesVM {
    isAlcopaActive: boolean;
    updateUserAlcopaCredentialStatus: FetchStatus;
    alcopaStatus: FetchStatus;
}

export const userAlcopaCredentialSelector = (state: AppState): PreferencesVM => ({
    isAlcopaActive: state.alcopa.access.isActif,
    alcopaStatus: state.alcopa.access.status,
    updateUserAlcopaCredentialStatus: state.alcopa.updateAccessStatus,
});
